<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb" v-if="!loading">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1"><router-link  to="/">{{$t('maintenances.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-1" ><router-link to="/maintenanceslist">{{$t('maintenances.breadcrumb_2')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li v-if="orderType == 'normal'" class="active mx-1 almarai-bold" aria-current="page">{{$t('maintenances.breadcrumb_3')}}</li>
            <li v-if="orderType == 'fast'" class="active mx-1 almarai-bold" aria-current="page">{{$t('requestExpress_maintenance')}}</li>
            <li v-if="orderType == 'mosque'" class="active mx-1 almarai-bold" aria-current="page">{{$t('maintenanceMosques')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div>
          <errorAlert v-if="hasError || errorList" :alertMessage="message" 
            :errorNumber="errorNumber" 
          />
        </div>
        <div v-if="loading" class="row justify-content-center">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div v-else class="row pt-2">
          <div v-if="!showProviderLookup" class="col">
            <div class="row justify-content-center" v-if="step == 1">
              <div class="col-11 col-md-8">
                <div class="row pt-3">
                  <div class="col maintenance" @click="nextStep('normal')">
                    <div class="almarai-bold">{{$t('maintenances.breadcrumb_3')}}</div>
                    <span class="text-center almarai-regular gray-color fonttext-14">
                      {{$t('maintenances.title_1')}} {{normalOrderPrice}} {{$t('maintenances.price')}}
                    </span>
                    <i class="fa-solid fa-chevron-left chevron-style"></i>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col maintenance" @click="nextStep('fast')">
                    <div class=" almarai-bold">{{$t('maintenances.title_2')}}</div>
                    <span class="text-center almarai-regular gray-color fonttext-14">
                      {{$t('maintenances.title_3')}} {{fastOrderPrice}} {{$t('maintenances.price')}}
                    </span>
                    <i class="fa-solid fa-chevron-left chevron-style"></i>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col maintenance" @click="nextStep('mosque')">
                    <div class=" almarai-bold">{{$t('maintenances.title_4')}} 🕌</div>
                    <span class="text-center almarai-regular gray-color fonttext-14">{{$t('maintenances.title_5')}}</span>
                    <i class="fa-solid fa-chevron-left chevron-style"></i>
                  </div>
                </div>
              </div>
            </div>

            <!--begin:maintenanceRequest-->
            <div class="row justify-content-center" v-if="step == 2">
              <div class="col-12 col-md-8">
                <!-- <div class="almarai-bold">طلب صيانه جديدة</div> -->
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="fonttext-14 gray-color">
                      {{$t('maintenances.title')}}
                      <span class="stars">*</span>
                    </label>
                    <input type="text" id="issueTitle" class="form-control input-style" v-model="title" >
                    <div class="error-feedback red-color fonttext-14" v-if="V$.title.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="fonttext-14 gray-color">
                      {{$t('maintenances.title_7')}}
                      <span class="stars">*</span>
                    </label>
                    <select @change="checkIssue" class="form-select input-style mb-3" v-model="issueType" aria-label="Large select example">
                      <option selected>{{$t('maintenances.title_8')}}</option>
                      <option v-for="(row, index) in rows" :key="index" :value="row.id">{{row.name}}</option>
                    </select>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.issueType.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>
                <div class="row pt-2" v-if="orderType !='mosque'">
                  <div class="col position-R">
                    <label class="fonttext-14 gray-color">{{$t('maintenances.title_9')}}</label>
                    <input type="text" id="discount" class="form-control input-style" v-model="discount">
                    <span class="discount" @click.prevent="checkDiscount">{{$t('maintenances.title_10')}}</span>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="fonttext-14 gray-color">
                      {{$t('maintenances.title_11')}}
                      <span class="stars">*</span>
                    </label>
                    <textarea class="form-control input-style" v-model="description" rows="4"></textarea>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.description.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col">
                    <label for="" class="fonttext-14 gray-color">
                      {{$t('maintenances.title_12')}}
                      <span class="stars">*</span>
                    </label>
                    <input type="file"  @change="uploadImage($event.target.files)" class="form-control input-style">
                    <div class="error-feedback red-color fonttext-14" v-if="V$.image.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                </div>

                <div class="row pt-3" v-if="orderType !='fast'">
                  <div class="col">
                    <div class="form-check">
                      <label class="form-check-label" for="checkDefault">
                        <input class="form-check-input radio-style" v-model="isSchedule" type="checkbox" value="" id="checkDefault">
                        {{$t('maintenances.scheduleMaintenance')}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row pt-2" v-if="isSchedule">
                  <div class="col">
                    <input
                      type="datetime-local"
                      id="meeting-time"
                      class="form-control input-style"
                      name="meeting-time"
                      value="2018-06-12T19:30"
                      v-model="scheduleDate"
                    />
                  </div>
                </div>
    
                <div class="row">
                  <div class="col">
                    <div class="almarai-bold py-2">{{$t('maintenances.title_13')}}</div>
                    <div ref="myMap" style="width: 100%; height: 320px;"></div>
                  </div>
                </div>
    
                <div class="row">
                  <div class="col-12 col-md-6 pb-2">
                    <label class="p-content" for="">{{$t('maintenances.title_14')}}</label>
                    <input type="number" class="form-control select-style" v-model="longitude">
                  </div>
                  <div class="col-12 col-md-6 pb-2">
                    <label class="p-content" for="">{{$t('maintenances.title_15')}}</label>
                    <input type="number" class="form-control select-style" v-model="latitude">
                  </div>
                </div>
    
                <div class="row pt-4 justify-content-center">
                  <div v-if="hasPackage && isFree && loadingIssue" class=" col-12 col-md-7 text-center">
                    <loader />
                  </div>
                  <div v-else class="col-11 col-md-5 text-center" @click.prevent="popupPaymentOrder">
                    <div class="btn-green">{{$t('maintenances.title_16')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!--End:maintenanceRequest-->
          </div>

          <div v-if="showProviderLookup" class="col">
            <div class="row justify-content-center">
              <div class="col-12 col-sm-8">
                <div class="row">
                  <div class="col-12 text-center mb-4">
                    <img src="/assets/images/map_search.gif" alt="">
                  </div>
                  <div class="col-12 mb-4">
                    <div class="alert alert-primary text-center" role="alert">{{ $t('maintenances.looking_provider') }} {{ minutes }}:{{ seconds }}</div>
                  </div>
                  <div class="col-12 mb-4">
                    <div class="row">
                      <div class="col">
                        <strong>{{ $t('maintenances.order_number') }}:</strong> {{ orderRow.id }}
                      </div>
                      <div class="col">
                        <strong>{{ $t('maintenances.service_name') }}:</strong> {{ (orderRow.MaintenanceIssue)? orderRow.MaintenanceIssue.name : 'غير معروف' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--begin:Modal Maintenance request successfully-->
    <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="successfully">
      <div class="modal-dialog width-800">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center pt-3">
              <div class="col-12 text-center">
                <img src="/assets/images/tick-circle.png" alt="">
              </div>
            </div>
            <div class="row pt-3">
              <div class="col text-center">
                <div class="font-24 almarai-bold text-center mb-1">{{$t('maintenances.title_17')}}</div>
                <div class="text-center fonttext-14 gray-color almarai-regular">{{$t('maintenances.title_18')}}</div>
              </div>
            </div>
            <div class="row py-3">
              <router-link to="/maintenanceslist">
                <div class="col mouse-hand" id="back">
                  <div class="back almarai-bold text-center">{{$t('maintenances.title_19')}}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--End:Modal Maintenance request successfully-->

    <!--begin:Modal PROVIDER NOT ACCEPTED-->
    <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="noProviders">
      <div class="modal-dialog width-800">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center pt-3">
              <div class="col-12 text-center">
                <img src="/assets/images/tick-circle.png" alt="">
              </div>
            </div>
            <div class="row pt-3">
              <div class="col text-center">
                <div class="font-24 almarai-bold text-center mb-1">{{$t('maintenances.order_received')}}</div>
                <div class="text-center fonttext-14 gray-color almarai-regular">{{$t('maintenances.manaule_assign')}}</div>
              </div>
            </div>
            <div class="row py-3">
              <router-link to="/maintenanceslist">
                <div class="col mouse-hand" id="back">
                  <div class="back almarai-bold text-center">{{$t('maintenances.title_19')}}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--End:Modal PROVIDER NOT ACCEPTED-->

    <!-- Button trigger modal -->
    <button type="button" id="coupon" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
    </button>

    <!-- Modal:begin couponPopup -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content br-radius-24">
          <div class="modal-body text-center">
            <div><img src="/assets/images/icons/new-success.png" class="w-25" alt=""></div>
            <h6 class="pt-3"><span class="ms-1">{{$t('maintenances.title_9')}}</span> {{value.amount}} {{(value.discountType == "percentage" )? '%' : $t('maintenances.title_22') }}</h6>
            <p>{{$t('maintenances.title_20')}}</p>
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <div type="button" class="btn-black" data-bs-dismiss="modal">{{$t('maintenances.title_21')}}</div>
              </div>
            </div>
          </div>            
        </div>
      </div>
    </div>
    <!-- end:couponPopup -->

    <!-- begin:modal-payment -->
    <!-- <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          
          <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div v-if="isLoading" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 text-center">
                <button @click.prevent="paymentMethod" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- end:modal-payment -->

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="documentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3" v-if="totalCost">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{(hasCoupon)? newDiscount : totalCost}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand show">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <!-- <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <div class="bankCard">{{$t('wallet.bankCard')}}</div> -->
                    <div class="row">
                      <div class="col-auto">
                        <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                      </div>
                      <div class="col p-0">
                        <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                        <div class="bankCard">{{$t('wallet.bankCard')}}</div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand show">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <!-- <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <div class="bankCard">{{$t('wallet.appWallet')}}</div> -->
                    <div class="row">
                      <div class="col-auto">
                        <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                      </div>
                      <div class="col p-0">
                        <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                        <div class="bankCard">{{$t('wallet.appWallet')}}</div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div v-if="isLoading" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-10 text-center">
                <div @click.prevent="paymentMethod" class="form-control almarai-bold btn-green">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-12 col-md-10">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->

    <!--begin:popup wallet balance -->
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header headerWallet">
            <button type="button" id="exit"  class="btn-close m-0" @click="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row">
              <div class="col-auto mouse-hand" @click="closeWalletBalance" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount === null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                {{totalCost}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div class="col text-start">
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                <del>{{totalCost}}</del>
              </div>
            </div>

            <div class="row" v-if="newDiscount !== null || discountPercentage">
              <div class="col-auto almarai-bold content-center">{{$t('priceDiscount')}}</div>
              <div class="col text-start">
                {{newDiscount}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{remainingBalance}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="isLoading" class="text-center">
                <loader />
              </div>
              <div v-else class="col-12 col-md-8 text-center" @click.prevent="orderCreate">
                <div class="btn-green">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:popup wallet balance -->

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: "maintenances",
  setup () {
    return { V$: useVuelidate() }
  },
  data(){
    return{
      orderT: this.$route.query.orderT,
      orderId: this.$route.query.orderId,
      step: 1,
      hasError: false,
      message: "",
      isLoading: false,
      loading: true,
      errorNumber: "",
      title: "",
      issueType: null,
      description: "",
      latitude: 24.7136,
      longitude: 46.6753,
      image: "",
      orderType: "",  
      rows: [],
      items:[],
      status: {},
      maintenanceType: 'current',
      errorList: false,
      prevOrders: [],
      discount: "",
      value: {},
      validateMessage: this.$t('validateMessage'),
      userLang: 'ar',
      type: this.$route.query.type ?? null,
      paymentGate: "",
      normalOrderPrice: null,
      fastOrderPrice: null,
      remainingBalance: 0,
      newDiscount: null,
      totalCost: 0,
      showProviderLookup: false,
      duration: 5 * 60,
      minutes: 0,
      seconds: 0,
      orderRow: {},
      timerInterval: null,
      getRowInterval: null,
      row: {},
      isSchedule: null,
      scheduleDate: "",
      hasPackage: null,
      isFree: null,
      discountPercentage: null,
      loadingIssue: false,
      hasCoupon: false,
    }
  },
  
  validations(){
    return {
      title: {required},
      issueType: {required},
      description: {required},
      image: {required},
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL','USER_WALLET_BALANCE'])
  },

  methods:{
    nextStep(val){
      this.orderType = val;
      if(this.orderType == 'normal'){
        this.totalCost = this.normalOrderPrice;
        this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.normalOrderPrice);
      }
      if(this.orderType == 'fast'){
        this.totalCost = this.fastOrderPrice;
        this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.fastOrderPrice);
      }
      this.step = 2;
      window.scroll(0,0);
    },
    async orderCreate(){
      this.isLoading = true;
      this.hasError = false;
      this.feedbackError= false;
      const formData = new FormData();
      formData.append('title', this.title);
      formData.append('orderType', this.orderType);
      formData.append('issueId', this.issueType);
      formData.append('latitude', this.latitude);
      formData.append('longitude', this.longitude);
      formData.append('description', this.description);
      formData.append('image', this.image);
      formData.append('coupon', this.discount);
      formData.append('paymentGate', this.paymentGate);
      formData.append('isSchedule', this.isSchedule);
      formData.append('scheduleDate', this.scheduleDate);
      this.$http.post("/api/orders/create",formData).then(res => {
        // console.log(res);
        if(this.orderType == 'mosque' || this.orderType == 'global' ){
          document.getElementById('successfully').style.display = 'block';
          this.isLoading = false;
          return false;
        }

        if(res.data.paymentUrl){
          window.location.href = res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById("closeModal").click();
            document.getElementById('popup_WalletBalance').style.display = 'none';
          }
          this.$router.replace(`/maintenancedetails/${res.data.row.id}`);
          // this.orderRow = res.data.row;
          // if(this.orderRow.status == 'new'){
          //   this.showProviderLookup = true;
          //   this.startTimer();
          //   this.checkOrderStatus();
          //   window.scroll(0,0);
          // }else{
          //   document.getElementById('successfully').style.display = 'block';
          // }
        }
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        document.getElementById("exit").click();
        window.scroll(0,0);
      });
    },
    uploadImage(files){
      this.image = files[0];
    },

    //function get Location user
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
          }
        );
      } else {
        // this.error = "Geolocation is not supported by this browser.";
      }
    },
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.latitude)? parseFloat(this.latitude) : 24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753 
        },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },

    getDatainitial(){
      this.hasError = false;
      this.$http.get("/api/orders/init").then(res => {
        // console.log(res);
        this.rows = res.data.issues;
        this.normalOrderPrice = res.data.normalOrderPrice;
        this.fastOrderPrice = res.data.fastOrderPrice;
        this.initialGoogleMap();
        window.scroll(0,0);
        // set cost 
        if(this.type){
          this.nextStep(this.type);
        }
        if(this.orderType == this.orderT) {
          this.nextStep();
        }
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    checkDiscount(){
      this.hasError = false;
      this.$http.post("/api/coupons/available",{
        coupon: this.discount,
      }).then(res => {
        // console.log(res);
        this.value = res.data.row;
        document.getElementById('coupon').click();
        if(this.value.discountType == 'percentage'){
          this.newDiscount = this.totalCost - ((this.totalCost * this.value.amount) /100);
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }else{
          this.newDiscount = this.totalCost - this.value.amount;
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.newDiscount);
        }
        this.hasCoupon = true;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.newDiscount = null;
        if(this.orderType == 'normal'){
          this.totalCost = this.normalOrderPrice;
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.normalOrderPrice);
        }
        if(this.orderType == 'fast'){
          this.totalCost = this.fastOrderPrice;
          this.remainingBalance = parseFloat(this.USER_WALLET_BALANCE) - parseFloat(this.fastOrderPrice);
        }
        this.hasCoupon = false;
      });
    },

    async popupPaymentOrder(){
      const isValid = await this.V$.$validate();
      if(!isValid){
        this.isLoading = false;
        window.scroll(0,0);
        return false;
      }

      if(this.hasPackage && this.isFree){
        this.orderCreate();
        return false;
      }

      if(this.hasCoupon && this.value.discountType == 'percentage' && this.value.amount == 100){
        this.orderCreate();
        return false;
      }

      if(this.totalCost){
        document.getElementById('selectPayment').click();
      }else{
        this.orderCreate();
      }
    },

    paymentMethod(){
      // if(this.discountPercentage) {
      //   this.newDiscount = this.totalCost - ((this.totalCost * this.discountPercentage) /100);
      // }
      
      if(this.paymentGate == 'online'){
        this.orderCreate();
      }else{
        this.showPopup();
      }
    },
    
    closeWalletBalance(){
      document.getElementById('popup_WalletBalance').style.display = 'none';
    },
    startTimer(){
      this.timerInterval = setInterval(() => {
        this.minutes = Math.floor(this.duration / 60);
        this.seconds = this.duration % 60;
        this.seconds = this.seconds < 10 ? '0' + this.seconds : this.seconds;

        if (--this.duration < 0) {
          this.clearMyIntervals();
          document.getElementById('noProviders').style.display = 'block';
        }
      }, 1000);
    },
    checkOrderStatus(){
      this.getRowInterval = setInterval(() => {
        this.$http.get("/api/orders/retrieve/"+this.orderRow.id).then(res => {
          if(res.data.row.status != 'new'){
            this.clearMyIntervals();
            this.$router.replace({name: 'MaintenanceDetails', params: { id: this.orderRow.id }});
          }
        }).catch(err => {
          this.clearMyIntervals();
          this.$router.replace({name: 'MaintenanceDetails', params: { id: this.orderRow.id }});
        });
      }, 30000);
    },
    clearMyIntervals(){
      if(this.timerInterval){
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      if(this.getRowInterval){
        clearInterval(this.getRowInterval);
        this.getRowInterval = null;
      }
    },

    maintenanceRequestDetails(){
      this.$http.get("/api/orders/retrieve/"+this.orderId).then(res => {
        this.title = res.data.row.title;
        this.issueType = res.data.row.issueId;
        this.discount = res.data.row.couponId;
        this.description = res.data.row.description;
        this.loading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.loading = false;
      });
    },

    checkIssue(){
      this.loadingIssue = true;
      this.$http.post('/api/orders/checkIssuePackage',{
        orderType: this.orderType,
        issueId: this.issueType,
      }).then(res => {
        // console.log(res);
        this.hasPackage = res.data.hasPackage;
        this.isFree = res.data.isFree;
        this.discountPercentage = res.data.discountPercentage;
        this.loadingIssue = false;
      }).catch(err => {
        this.loadingIssue = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    showPopup(){
      document.getElementById('closeModal').click();
      if(this.totalCost > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        if(!this.hasCoupon)
          this.remainingBalance =  this.USER_WALLET_BALANCE - this.totalCost;
        document.getElementById('popup_WalletBalance').style.display = 'block';
      }
    },

    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },
  },
  created(){
    this.getDatainitial();
    this.getLocation();
    this.orderT = this.orderType;
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    if(this.orderId){
      this.maintenanceRequestDetails();
    }
  },

  unmounted(){
    this.clearMyIntervals();
  }
  
}
</script>